import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-valid-icon-toggle',
    imports: [
        MatIconModule,
    ],
    templateUrl: './valid-icon-toggle.component.html',
    styleUrl: './valid-icon-toggle.component.scss'
})
export class ValidIconToggleComponent {
  @Input() isValid = false;

  public setValid(isValid: boolean) {
    this.isValid = isValid;
  }
}
